// Mobile Slider
if ($('.how-to-slider-mobile').length > 0) {
  function mobileSlider() {
    const $howToSlider = $('.how-to-slider-mobile');
    const $status = $('.how-to-slider-paging');

    $howToSlider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
      if (!slick.$dots) {
        return;
      }

      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + (slick.$dots[0].children.length));

      $('.how-to-slider-mobile .video video').each(function() {
        $(this).trigger('pause');
      });

      $('.how-to-slider-mobile .video[data-index="' + i + '"] video').trigger('play');
    });

    $howToSlider.slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '.how-to-slider-prev',
      nextArrow: '.how-to-slider-next',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  $(window).on('resize', function() {
    if ($(window).width() < 992) {
      if ($('.how-to-slider-mobile').hasClass('slick-initialized')) {
        return;
      }
      mobileSlider();
    }
    if ($(window).width() >= 992) {
      $('.how-to-slider-mobile').slick('unslick');
    }
  });

  if ($(window).width() < 992) {
    mobileSlider();

  }
}

// Desktop
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 992) {
    const video = document.querySelector('.how-to-slider-desktop .how-to-media .video[data-index="1"] video');

    if (video) {
      video.play()
        .catch(error => {
          console.error('Error trying to play the video:', error);
        });
    }
  }

  const stepInfos = document.querySelectorAll('.how-to-step-info');

  stepInfos.forEach(function(stepInfo) {
    stepInfo.addEventListener('click', function() {
      const dataIndex = this.getAttribute('data-index');
      const steps = document.querySelectorAll('.how-to-step-desktop');
      const stepVideo = document.querySelector('.how-to-slider-desktop .how-to-media .video[data-index="' + dataIndex + '"] video');

      steps.forEach(function(step) {
        step.classList.add('d-none');
        document.querySelectorAll('.how-to-step-info').forEach(function(thisStep) {
          thisStep.classList.remove('selected');
        });
        document.querySelector('.how-to-step-info[data-index="' + dataIndex + '"]').classList.add('selected');
      });

      const matchingStep = document.querySelector('.how-to-step-desktop[data-index="' + dataIndex + '"]');
      if (matchingStep) {
        matchingStep.classList.remove('d-none');
      }
      if (stepVideo) {
        stepVideo.play()
          .catch(error => {
            console.error('Error trying to play the video:', error);
          });
      }
    });
  });
});